import React, { useRef, useCallback } from "react";

import { Button } from "../base/Button";
import InfoDiv from "../InfoDiv";

export default function LoginForm(props: {
  errors?: any;
  onSubmit: (data: { username?: string; password?: string }) => void;
}) {
  const { errors = {}, onSubmit } = props;
  const userInput = useRef<HTMLInputElement>(null);
  const passwordInput = useRef<HTMLInputElement>(null);
  const handleSubmit = useCallback<React.FormEventHandler<HTMLFormElement>>(
    (evt) => {
      evt.preventDefault();
      onSubmit({
        username: userInput.current?.value,
        password: passwordInput.current?.value,
      });
    },
    [onSubmit]
  );
  const FormError = (errorField: string) =>
    errors instanceof Object &&
    errors[errorField] && (
      <InfoDiv type="error">{errors[errorField][0]}</InfoDiv>
    );

  return (
    <form
      className="text-center flex flex-col space-y-4"
      onSubmit={handleSubmit}
    >
      <input type="text" ref={userInput} placeholder="Enter username" />
      {FormError("username")}
      <input type="password" ref={passwordInput} placeholder="Enter password" />
      {FormError("password")}
      <Button type="submit">Login</Button>
      {FormError("non_field_errors")}
    </form>
  );
}
